import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GetREWARDS_TYPE } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupRewardType = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const { REWARDS_TYPE, loading, error } = useSelector(state => state.Lookup);

  useEffect(() => {
    if (true) {
      dispatch(GetREWARDS_TYPE());
    }
  }, []);

  const REWARDSTYPE_OPTIONS =
    REWARDS_TYPE &&
    REWARDS_TYPE?.map((item, idx) =>
      item.list?.map(list => ({
        value: list.lookupCode,
        label: i18n.language === 'en' ? list.meaning : list.meaning2
      }))
    ).flat();

  return { REWARDS_TYPE, REWARDSTYPE_OPTIONS, loading, error };
};

export default useLookupRewardType;
